import React from 'react';

import { TEST_API_ROLE } from '../../../../../constants/bot';

import UserQuery from '../UserQuery/UserQuery';
import ApiResponse from '../ApiResponse/ApiResponse';

const ApiPreviewMessages = ({ message, handleRegenerate, isRegenerateDisabled }) => {
    if (!message) return <></>;

    const { role } = message;

    if (role === TEST_API_ROLE.user) {
        return <UserQuery message={message} />;
    }

    if (role === TEST_API_ROLE.api) {
        return (
            <ApiResponse
                message={message}
                handleRegenerate={handleRegenerate}
                isRegenerateDisabled={isRegenerateDisabled}
            />
        );
    }

    return <></>;
};

export default ApiPreviewMessages;
